export const SET_SUPPLIER_COLLECTION = 'PERSON/SET_SUPPLIER_COLLECTION';
export const SET_CLIENT_COLLECTION = 'PERSON/SET_CLIENT_COLLECTION';
export const SET_SHIPPING_COMPANY_COLLECTION = 'PERSON/SET_SHIPPING_COMPANY_COLLECTION';
export const SET_VEHICLE_COLLECTION = 'PERSON/SET_VEHICLE_COLLECTION';
export const SET_ADDRESS_COLLECTION = 'PERSON/SET_ADDRESS_COLLECTION';
export const SET_UF_COLLECTION = 'PERSON/SET_UF_COLLECTION';
